import { render, staticRenderFns } from "./AlDropdownHeader.vue?vue&type=template&id=885de106&"
import script from "./AlDropdownHeader.vue?vue&type=script&lang=js&"
export * from "./AlDropdownHeader.vue?vue&type=script&lang=js&"
import style0 from "./AlDropdownHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports